import { getItemFromCollection } from "directus/src/operations";
import { apiRoot } from "services/src/config";

export async function fetchRepo({ id }) {
  // Row ids in the global list are git_repositories ids now.
  return getItemFromCollection("git_repositories", id, {
    fields: ["id", "repository_id", "repository_url", "suffix", "visibility", "flag"],
  });
}

// Repository name from its URL: https://github.com/org/name -> "name".
export const repoNameFromUrl = (url) => url?.replace(/\/+$/, "").split("/").pop() || "";

// Syncs the repositories of the GitHub organization into git_repositories.
// With gitRepositoryId (git_repositories row id) only that repository is synced.
export async function syncRepositories({ gitRepositoryId } = {}) {
  const { data } = await apiRoot.post(
    "github/sync-repositories",
    gitRepositoryId ? { git_repository_id: gitRepositoryId } : undefined,
  );
  return data;
}

// Summary for the stat cards (one request, up to 100 branches).
export async function fetchBranchSummary({ repository_url }) {
  const { data } = await apiRoot.get("github/repository/branches", {
    params: { repository_url, page: 1, limit: 100 },
  });
  return { items: data?.data || [], total: data?.totalRecords ?? 0 };
}

// Moves the branch HEAD from current_head to expected_head. Backend rejects a stale current_head.
export async function resetBranch({ repository_url, branch, current_head, expected_head }) {
  const { data } = await apiRoot.patch("github/repository/reset_branch", {
    repository_url,
    branch,
    current_head,
    expected_head,
  });
  return data;
}
